import React, { useState, useEffect } from 'react';
import './psychometricDashboard.css';
import testImage from '../../../assets/images/im_Post Login welcome candidate.png';
import { PsychometricService } from '../../../services/psychometricService';
import moment from 'moment';
import 'moment-timezone';
import ClientUserService from '../../../services/client-services/clientUserService';
import { Link, useNavigate } from 'react-router-dom';
import profilebackButtonIcon from '../../../assets/images/Ic_back.png';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';
import { set } from 'lodash';
import { decodeJWT } from '../../../services/candidateService';
import { CandidateService } from '../../../services/candidateService';
import { serverConfig } from '../../../services/server-config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

const PsychometricDashboard = () => {
    const [showModal, setShowModal] = useState(false);
    const [testLink, setTestLink] = useState('');
    const [loader, setLoader] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [resultsModalOpen, setResultsModalOpen] = useState(false);
    const [assessmentResults, setAssessmentResults] = useState(null);
    const [showTestReminderModal, setShowTestReminderModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [takePurcchasedAssessmentloading, setTakePurcchasedAssessmentloading] = useState(false);
    const [assesments, setAssessments] = useState([]);
    const [purchasedAssessments, setPurchasedAssessments] = useState([]);
    const [ongoingAssessments, setOngoingAssessments] = useState([]);
    const [selectedAssessment, setSelectedAssessment] = useState(null);
    const [purchasedWithTxns, setPurchasedWithTxns] = useState([]);
    const [completedAssessments, setCompletedAssessments] = useState([]);
    const [loadingIndex, setLoadingIndex] = useState(null);
    const [pageLoader, setPageLoader] = useState(true);
    const [candidateProfile, setCandidateProfile] = useState(null);


    const token = window.localStorage.getItem('authToken');
    const decoded = decodeJWT(token);
    console.log(decoded)
    const candidateId = _.get(decoded, "username", "");
    useEffect(() => {
        if (!candidateId) return;

        const fetchCandidate = async () => {
            try {
                const response = await CandidateService.getCandidateById(candidateId);
                if (response.status === 200 && response.data?.candidates?.length > 0) {
                    setCandidateProfile(response.data.candidates[0].candidate);
                }
            } catch (err) {
                console.error("Failed to fetch candidate:", err);
            }
        };

        fetchCandidate();
    }, [candidateId]);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                setPageLoader(true);

                const [masterRes, purchasedRes, purchasedTxnRes] = await Promise.all([
                    CandidatePostLoginService.getAssesmentMasterData(),
                    CandidatePostLoginService.getAvailableAssessmentList(),
                    CandidatePostLoginService.getPurchasedAssesmentList(),
                ]);

                if (masterRes.status === 200) {
                    setAssessments(masterRes.data || []);
                    if (masterRes.data?.length > 0) setSelectedAssessment(masterRes.data[0]);
                }

                if (purchasedRes.status === 200) {
                    setPurchasedAssessments(purchasedRes.data?.availableAssessmentsLst || []);
                }

                if (purchasedTxnRes.status === 200) {
                    setPurchasedWithTxns(purchasedTxnRes.data?.candidateAssessmentDetails || []);
                }

                // Fetch ongoing assessments
                const ongoingRes = await CandidatePostLoginService.getOngoingAssessmentList();
                if (ongoingRes.status === 200) {
                    const responses = _.get(ongoingRes, "data.assessments.assessmentResponses", []);
                    const ongoing = [];
                    responses.forEach((group) => {
                        if (group.assessmentInformationLst?.length > 0) ongoing.push(group);
                    });
                    setOngoingAssessments(ongoing);
                }

                // Fetch completed assessments
                const completedRes = await CandidatePostLoginService.getCompletedAssessmentList();
                if (completedRes.status === 200) {
                    const responses = _.get(completedRes, "data.assessments.assessmentResponses", []);
                    const completed = [];
                    responses.forEach((group) => {
                        group.assessmentInformationLst?.forEach((assessment) => {
                            const dto = assessment.discAssessmentDTO;
                            if (dto?.status === "completed") {
                                completed.push({
                                    transactionId: assessment.transactionId,
                                    assessmentType: assessment.assessmentType,
                                    completedDate: dto?.results?.completedDate || null,
                                    assessmentUrl: assessment.assessmentUrl,
                                    reportS3Path: dto?.reportS3Path,
                                    fileName: dto?.fileName,
                                });
                            }
                        });
                    });
                    setCompletedAssessments(completed);
                }

            } catch (err) {
                console.error("Error loading initial data:", err);
            } finally {
                setPageLoader(false);
            }
        };

        loadInitialData();
    }, []);


    const refreshData = async () => {
        try {
            const [purchasedRes, ongoingRes, completedRes] = await Promise.all([
                CandidatePostLoginService.getAvailableAssessmentList(),
                CandidatePostLoginService.getOngoingAssessmentList(),
                CandidatePostLoginService.getCompletedAssessmentList(),
            ]);

            if (purchasedRes.status === 200) {
                setPurchasedAssessments(purchasedRes.data?.availableAssessmentsLst || []);
            }

            if (ongoingRes.status === 200) {
                const responses = _.get(ongoingRes, "data.assessments.assessmentResponses", []);
                const ongoing = [];
                responses.forEach((group) => {
                    if (group.assessmentInformationLst?.length > 0) ongoing.push(group);
                });
                setOngoingAssessments(ongoing);
            }

            if (completedRes.status === 200) {
                const responses = _.get(completedRes, "data.assessments.assessmentResponses", []);
                const completed = [];
                responses.forEach((group) => {
                    group.assessmentInformationLst?.forEach((assessment) => {
                        const dto = assessment.discAssessmentDTO;
                        if (dto?.status === "completed") {
                            completed.push({
                                transactionId: assessment.transactionId,
                                assessmentType: assessment.assessmentType,
                                completedDate: dto?.results?.completedDate || null,
                                assessmentUrl: assessment.assessmentUrl,
                                reportS3Path: dto?.reportS3Path,
                                fileName: dto?.fileName,
                            });
                        }
                    });
                });
                setCompletedAssessments(completed);
            }

        } catch (err) {
            console.error("Error refreshing data:", err);
        }
    };

    const formatISTDatetime = (utcDateStr) => {
        if (!utcDateStr) return 'N/A';
        return moment.utc(utcDateStr).tz('Asia/Kolkata').format('DD MMM YYYY');
    };

    const downloadFile = (resumePath, fileName) => {
        if (!resumePath) {
            console.error("Missing file path");
            return;
        }
        ClientUserService.downloadFile(encodeURI(resumePath))
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => console.error(err));
    };

    const handleTakeTest = async (assessmentId) => {
        setTakePurcchasedAssessmentloading(true);
        try {
            const response = await CandidatePostLoginService.startAssessment(assessmentId);
            if (response.status === 200 && response.data?.assessmentUrl) {
                const url = response.data.assessmentUrl;
                setTestLink(url);
                setShowModal(true);

                setPurchasedAssessments((prev) =>
                    prev.filter((item) => item.assessmentId !== assessmentId)
                );

                CandidatePostLoginService.getOngoingAssessmentList().then((res) => {
                    if (res.status === 200) {
                        const responses = _.get(res, "data.assessments.assessmentResponses", []);
                        const ongoing = [];
                        const completed = [];

                        responses.forEach((group) => {
                            const ongoingList = [];
                            group.assessmentInformationLst?.forEach((assessment) => {
                                const dto = assessment.discAssessmentDTO;
                                if (dto?.status === "completed") {
                                    completed.push({
                                        transactionId: assessment.transactionId,
                                        assessmentType: assessment.assessmentType,
                                        completedDate: dto?.results?.completedDate || null,
                                        assessmentUrl: assessment.assessmentUrl,
                                    });
                                } else {
                                    ongoingList.push(assessment);
                                }
                            });

                            if (ongoingList.length > 0) {
                                ongoing.push({ ...group, assessmentInformationLst: ongoingList });
                            }
                        });

                        setOngoingAssessments(ongoing);
                        setCompletedAssessments(completed);
                    }
                });
            } else {
                console.error('Unexpected response:', response);
            }
        } catch (error) {
            console.error('Error during DISC registration:', error);
        } finally {
            setTakePurcchasedAssessmentloading(false);
        }
    };


    const handleViewScores = async (transactionId, index) => {
        setLoadingIndex(index);
        try {
            const response = await PsychometricService.getResults(transactionId);

            if (response.status === 200 &&
                response.data?.discAssessmentDTO?.status === "completed") {

                setAssessmentResults(response.data);
                setResultsModalOpen(true);
            } else {
                console.warn("No completed results found or unexpected format", response.data);
            }
        } catch (error) {
            if (error.response?.data?.message === "Unregistered DISC user") {
                setShowTestReminderModal(true);
            } else {
                console.error('Request failed:', error.message);
            }
        } finally {
            setLoadingIndex(null);
        }
    };

    const handlePurchaseAssessment = async () => {
        if (!selectedAssessment) {
            alert("No assessment available to purchase.");
            return;
        }

        setButtonLoading(true);

        try {
            const response = await CandidatePostLoginService.purchaseAssesment(
                selectedAssessment.assessmentId
            );

            if (response.status === 200 && response.data?.paymentGatewayDTO?.razorpayOrder) {
                const order = response.data.paymentGatewayDTO.razorpayOrder;

                const options = {
                    key: serverConfig.razorPayKey,
                    amount: order.amount,
                    currency: order.currency,
                    name: "Leaderly",
                    description: "Psychometric Assessment Purchase",
                    order_id: order.orderId,
                    handler: async function (paymentResponse) {
                        try {
                            await CandidatePostLoginService.verifyPayment({
                                razorpay_payment_id: paymentResponse.razorpay_payment_id,
                                razorpay_order_id: paymentResponse.razorpay_order_id,
                                razorpay_signature: paymentResponse.razorpay_signature,
                            });
                            alert("Payment Successful! 🎉 You can now take your assessment.");
                            setLoader(true);
                            refreshData();
                            setLoader(false);

                        } catch (err) {
                            console.error("Payment verification failed:", err);
                            alert("Payment verification failed. Please contact support.");
                        }
                    },

                    prefill: {
                        email: candidateProfile?.personalDetails?.primaryEmailId || "",
                        contact: candidateProfile?.personalDetails?.primaryPhoneNumber || "",
                    },

                    notes: {
                        transactionId: response.data.transactionId,
                    },
                    theme: {
                        color: "#3399cc",
                    },
                };

                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                alert("Failed to create order. Please try again.");
            }
        } catch (error) {
            console.error("Purchase failed:", error);
            alert("Something went wrong. Please try again.");
        } finally {
            CandidatePostLoginService.getAvailableAssessmentList().then((response) => {
                if (response.status === 200) {
                    const purchasedAssessments = response.data?.availableAssessmentsLst;
                    setPurchasedAssessments(purchasedAssessments);
                }

            });

            setButtonLoading(false);
        }
    };

    const startPollingForCompletion = () => {
        const intervalId = setInterval(async () => {
            try {
                const ongoingRes = await CandidatePostLoginService.getOngoingAssessmentList();

                if (ongoingRes.status === 200) {
                    const responses = _.get(ongoingRes, "data.assessments.assessmentResponses", []);
                    const ongoing = [];

                    responses.forEach((group) => {
                        if (group.assessmentInformationLst?.length > 0) {
                            ongoing.push(group);
                        }
                    });

                    setOngoingAssessments(ongoing);

                    if (ongoing.length === 0) {
                        clearInterval(intervalId);

                        const completedRes = await CandidatePostLoginService.getCompletedAssessmentList();
                        if (completedRes.status === 200) {
                            const responses = _.get(completedRes, "data.assessments.assessmentResponses", []);
                            const completed = [];

                            responses.forEach((group) => {
                                group.assessmentInformationLst?.forEach((assessment) => {
                                    const dto = assessment.discAssessmentDTO;
                                    if (dto?.status === "completed") {
                                        completed.push({
                                            transactionId: assessment.transactionId,
                                            assessmentType: assessment.assessmentType,
                                            completedDate: dto?.results?.completedDate || null,
                                            assessmentUrl: assessment.assessmentUrl,
                                            reportS3Path: dto?.reportS3Path,
                                            fileName: dto?.fileName,
                                        });
                                    }
                                });
                            });

                            setCompletedAssessments(completed);
                        }
                    }
                }
            } catch (err) {
                console.error("Polling error:", err);
                clearInterval(intervalId);
            }
        }, 10000);
    };

    return (
        <>
            {/* Breadcrumb */}
            <div className="profile-candidate-breadcrumb mb-3">
                <div className="breadcrumb-candidate">
                    <Link
                        to={-1}
                        style={{ color: '#99A4AF', textDecoration: 'none' }}
                        state={{ scrollPosition: sessionStorage.getItem("initialScrollPosition") }}
                    >
                        <img src={profilebackButtonIcon} alt="Back" className="profile-breadcrumb-back-icon" />{' '}
                        <span className="profile-breadcrumb-back-text">Back</span>
                    </Link>
                </div>
            </div>
            {pageLoader ? (
                <div className="psychometric-loader-container">
                    <div className="psychometric-loader"></div>
                </div>
            ) : (
                <div className="psychometric-dashboard-container">

                    <div className="psychometric-dashboard-header">
                        <h1>Candidate Psychometric Assessment</h1>
                        <p>In leadership hiring, the DISC Assessment helps employers understand a candidate’s natural leadership style, decision-making approach, and communication strengths. This insight supports better role fit, stronger team dynamics, and alignment with an organization’s culture and leadership needs.</p>
                    </div>
                    <br /><br />

                    <div className="psychometric-top-row">
                        <div className="psychometric-text-section">
                            <h2>Before you start your test</h2>
                            <p>
                                <ul>
                                    <li>Find a quiet space: Make sure you’re in a comfortable, distraction-free environment.</li>
                                    <li>Set aside 10–15 minutes: The assessment is quick and should be completed in one sitting.</li>
                                    <li>Answer honestly: There are no right or wrong answers. Choose the options that best reflect how you naturally think and behave — not how you wish to be.</li>
                                    <li>Trust your first instinct: Go with your gut reaction rather than overthinking.</li>
                                    <li>Complete all questions: Answer every question to get accurate results.</li>
                                    <li>Submit and view your results: Once done, click Submit to save your answers.</li>
                                </ul>
                            </p>
                            <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "8px", fontSize: "16px" }}>

                                <FontAwesomeIcon icon={faFilePdf} color="#F35824" size="2x" />
                                <a
                                    href="/sample-report-psychometric/John_Doe_DISC_BASIC_-_Summary.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "underline", color: "#F35824", fontWeight: 500, fontSize: "16px" }}
                                >
                                    View a Sample DISC Report
                                </a>
                            </div>
                        </div>

                        <div className="psychometric-image-section">
                            <img src={testImage} alt="Psychometric Test" className="psychometric-test-image" />
                        </div>
                    </div>

                    <div className="psychometric-bottom-row">
                        <div className="psychometric-take-test-card">
                            <h4>Assessments</h4>
                            <p>Please purchase the assessment.</p>
                            {assesments.length > 0 && (
                                <input
                                    type="text"
                                    className="psychometric-assessment-input"
                                    value={`${assesments[0].assessmentName} - ₹${assesments[0].price}`}
                                    readOnly
                                />
                            )}

                            <button
                                className="psychometric-take-test-button"
                                onClick={handlePurchaseAssessment}
                                disabled={buttonLoading || assesments.length === 0}
                            >
                                {buttonLoading ? (
                                    <span className="psychometric-button-spinner"></span>
                                ) : (
                                    "Purchase Assessment"
                                )}
                            </button>
                        </div>


                        {completedAssessments.length > 0 && (
                            <div className="psychometric-scores-card">
                                <h4>Completed Assessment Reports</h4>
                                <p>You can download the report here. Your report will also be available in your candidate profile.</p>

                                {completedAssessments.map((assessment, index) => (
                                    <button
                                        key={assessment.transactionId}
                                        className="psychometric-take-test-button"
                                        onClick={() => handleViewScores(assessment.transactionId, index)}
                                        disabled={loadingIndex === index}
                                        style={{
                                            minWidth: 160,
                                            height: 38,
                                            display: 'inline-flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginBottom: 10,
                                        }}
                                    >
                                        {loadingIndex === index ? (
                                            <div
                                                className="spinner-border spinner-border-sm text-light"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        ) : (
                                            `${index + 1}. Download ${assessment.assessmentType} Report (Completed on ${formatISTDatetime(assessment.completedDate)})`

                                        )}
                                    </button>
                                ))}
                            </div>
                        )}

                        {purchasedAssessments.length > 0 && (
                            <div className="psychometric-scores-card" style={{ marginTop: 20 }}>
                                <h4>Your Purchased Assessments</h4>
                                {
                                    purchasedAssessments.map((assessment) => (
                                        <button
                                            className="psychometric-take-test-button"
                                            onClick={async () => await handleTakeTest(assessment.assessmentId)}
                                            disabled={takePurcchasedAssessmentloading}
                                            key={assessment.assessmentId}
                                            style={{
                                                minWidth: 160,
                                                height: 38,
                                                display: 'inline-flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {assessment.displayValue} (Remaining: {assessment.count})
                                        </button>
                                    ))

                                }
                            </div>)
                        }
                        {/* Ongoing Assessments */}
                        {ongoingAssessments?.length > 0 && (
                            <div className="psychometric-scores-card" style={{ marginTop: 20, overflowY: 'scroll', maxHeight: 300 }}>
                                <h4>Your Ongoing Assessments</h4>
                                {
                                    ongoingAssessments.map(ongingAssessment => ongingAssessment.assessmentInformationLst?.map((assessment) => (
                                        <button
                                            className="psychometric-take-test-button"
                                            onClick={() => {
                                                window.open(assessment.assessmentUrl, '_blank');
                                                startPollingForCompletion();
                                            }} disabled={loading}
                                            key={assessment.transactionId
                                            }
                                            style={{
                                                minWidth: 160,
                                                height: 38,
                                                display: 'inline-flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {assessment.assessmentType} - Started on {formatISTDatetime(assessment.registeredDate)}
                                        </button>
                                    )))

                                }
                            </div>)
                        }

                    </div>
                    {showModal && (
                        <div className="psychometric-test-modal-overlay">
                            <div className="psychometric-test-modal">
                                <h3>You're Ready to Begin</h3>
                                <p>Click below to proceed to your psychometric test.</p>
                                <button className="psychometric-close-button" onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>{' '}
                                <button
                                    className="psychometric-proceed-button"
                                    onClick={() => {
                                        window.open(testLink, '_blank');
                                        setShowModal(false);
                                        startPollingForCompletion();
                                    }}
                                >
                                    Proceed to Take Test
                                </button>

                            </div>
                        </div>
                    )}
                    {resultsModalOpen && assessmentResults && (
                        <div className="psychometric-test-modal-overlay">
                            <div className="psychometric-test-modal">
                                <h3>Assessment Results</h3>

                                {(() => {
                                    const completedDto = assessmentResults.discAssessmentDTO;

                                    return completedDto?.status === "completed" ? (
                                        <div>
                                            <p><strong>Style Name :</strong> {completedDto.results?.styleName || 'N/A'}</p>
                                            <p><strong>Completed On :</strong> {formatISTDatetime(completedDto.results?.completedDate)}</p>

                                            <div className="psychometric-score-grid">
                                                <div><strong>Adaptive D :</strong> {Math.round(completedDto.results?.adaptiveDScore || 0)}</div>
                                                <div><strong>Adaptive I :</strong> {Math.round(completedDto.results?.adaptiveIScore || 0)}</div>
                                                <div><strong>Adaptive S :</strong> {Math.round(completedDto.results?.adaptiveSScore || 0)}</div>
                                                <div><strong>Adaptive C :</strong> {Math.round(completedDto.results?.adaptiveCScore || 0)}</div>
                                                <div><strong>Natural D :</strong> {Math.round(completedDto.results?.naturalDScore || 0)}</div>
                                                <div><strong>Natural I :</strong> {Math.round(completedDto.results?.naturalIScore || 0)}</div>
                                                <div><strong>Natural S :</strong> {Math.round(completedDto.results?.naturalSScore || 0)}</div>
                                                <div><strong>Natural C :</strong> {Math.round(completedDto.results?.naturalCScore || 0)}</div>
                                            </div>

                                            {completedDto.reportS3Path && (
                                                <button
                                                    className="psychometric-proceed-button"
                                                    onClick={() =>
                                                        downloadFile(
                                                            completedDto.reportS3Path,
                                                            `Psychometric_Report_${assessmentResults.candidateId}.pdf`
                                                        )
                                                    }
                                                >
                                                    📄 Download Full Report
                                                </button>
                                            )}
                                        </div>
                                    ) : (
                                        <p>No completed results available.</p>
                                    );
                                })()}

                                <button className="psychometric-close-button" onClick={() => setResultsModalOpen(false)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    )}

                </div>

            )}

            {showTestReminderModal && (
                <div className="psychometric-test-modal-overlay">
                    <div className="psychometric-test-modal">
                        <p>Please take the DISC assessment before you can view or download your report.</p>
                        <div style={{ marginTop: '20px' }}>
                            <button
                                className="psychometric-proceed-button"
                                onClick={() => {
                                    setShowTestReminderModal(false);
                                    handleTakeTest();
                                }}
                                disabled={buttonLoading}
                            >
                                {buttonLoading ? (
                                    <span className="psychometric-button-spinner"></span>
                                ) : (
                                    'Take Test Now'
                                )}
                            </button>{' '}
                            <button
                                className="psychometric-close-button"
                                onClick={() => setShowTestReminderModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PsychometricDashboard;